import { Box, Textarea, Skeleton } from "@mantine/core";
import type { ProviderViewModel } from "@models/provider";
import type { ModelBasicInfoViewModel, ModelViewModel } from "@models/model";
import { ProviderModelSelect } from "../ProviderModelSelect";
import "./OCRConfigTab.scss";

interface OCRConfigTabProps {
    isLoadingProviders: boolean;
    isLoadingModels?: boolean;
    providers: ProviderViewModel[];
    models: ModelBasicInfoViewModel[];
    selectedProvider: string;
    selectedModel: ModelViewModel | null;
    ocrOptions: string;
    onProviderChange: (providerKey: string) => void;
    onModelChange: (modelName: string) => void;
    onOcrOptionsChange: (value: string) => void;
}

export const OCRConfigTab = ({
    isLoadingProviders,
    isLoadingModels,
    providers,
    models,
    selectedProvider,
    selectedModel,
    ocrOptions,
    onProviderChange,
    onModelChange,
    onOcrOptionsChange,
}: OCRConfigTabProps) => {
    if (isLoadingProviders) {
        return (
            <Box className="ocr-config-tab__form">
                <Skeleton height={56} />
                <Skeleton height={56} />
                <Skeleton height={120} />
                <Skeleton height={200} />
            </Box>
        );
    }

    return (
        <Box className="ocr-config-tab__form">
            <ProviderModelSelect
                isLoadingProviders={isLoadingProviders}
                isLoadingModels={isLoadingModels}
                providers={providers}
                models={models}
                selectedProvider={selectedProvider}
                selectedModel={selectedModel}
                onProviderChange={onProviderChange}
                onModelChange={onModelChange}
            />

            <Textarea
                label="OCR Options (JSON)"
                value={ocrOptions}
                onChange={(e) => onOcrOptionsChange(e.currentTarget.value)}
                rows={8}
                placeholder='{"language": "en"}'
                description="Optional: JSON object with OCR configuration parameters"
            />
        </Box>
    );
};
